<template lang="pug">
  transition(appear)
    ul.ResultsList
        li(v-for="item in items")
              SampleListItem(:item="item")

</template>

<script>

import SampleListItem from '@/components/SampleListItem'

export default {
  props: {
    items: {}
  },
  components: {
    SampleListItem
  }
}
</script>

<style lang="stylus" >
.ResultsList
  position absolute
  top 0
  left 0
  padding 0
  margin 0
  overflow auto
  width 100%
  height 100%
  font-size 0
  scroll-behavior smooth
  transform scale(1)

  &.v-enter, &.v-leave-to
    opacity 0
    transform scale(1.5)

  &.v-enter-active, &.v-leave-active
    transition all 1.2s $ease

  @media $mq_s_only
    width 100%
    height calc(100vh  - 140px)

  li
    position relative
    display inline-block
    width 33.3%

    @media screen and (max-width: 1024px)
      width 50%

    @media screen and (max-width: 400px)
      width 100%

</style>
